import { getData, postData, putData } from 'src/api/http.service';
import {
  handleApiSuccess,
  handleApiError,
  generateUserInfoHeader,
  getDataFromSessionStorage,
} from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

const UserManagementActionTypes = {
  LOAD_USERS_SUCCESS: 'LOAD_USERS_SUCCESS',
  LOAD_USERS_ERROR: 'LOAD_USERS_ERROR',

  LOAD_ROLES_SUCCESS: 'LOAD_ROLES_SUCCESS',
  LOAD_ROLES_ERROR: 'LOAD_ROLES_ERROR',

  LOAD_COURSE_SUCCESS: 'LOAD_COURSE_SUCCESS',
  LOAD_COURSE_ERROR: 'LOAD_COURSE_ERROR',

  SAVE_USER_SUCCESS: 'SAVE_USER_SUCCESS',
  SAVE_USER_ERROR: 'SAVE_USER_ERROR',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  ADD_USER_ERROR: 'ADD_USER_ERROR',
  API_CALL_IN_PROGRESS: 'API_CALL_IN_PROGRESS',
  API_CALL_SUCCESS: 'API_CALL_SUCCESS',
  API_SUCCESS_RESPONSE: 'API_SUCCESS_RESPONSE',

  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
};

// plain actions -------------------------------------------------------------------------
function loadUserSuccess(response) {
  return { type: UserManagementActionTypes.LOAD_USERS_SUCCESS, payload: response };
}

function saveUserSuccess(response) {
  return { type: UserManagementActionTypes.SAVE_USER_SUCCESS, payload: response };
}

function addUserSuccess(response) {
  return { type: UserManagementActionTypes.ADD_USER_SUCCESS, payload: response };
}

function loadRoleSuccess(response) {
  return { type: UserManagementActionTypes.LOAD_ROLES_SUCCESS, payload: response };
}

function loadCourseSuccess(response) {
  return { type: UserManagementActionTypes.LOAD_COURSE_SUCCESS, payload: response };
}

// Async functions ********************************************************************************
function GetUsersAction(payload, metaData) {
  return async function(dispatch) {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(
        payload,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(loadUserSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function GetAllRolesAction(payload, metaData) {
  return async function(dispatch) {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload);
      dispatch(loadRoleSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function GetAllCoursesAction(payload, metaData) {
  return async function(dispatch) {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload);
      dispatch(loadCourseSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function AddNewUserAction(payload, data, metaData) {
  return async function(dispatch) {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(
        payload,
        data,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(addUserSuccess(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

function SaveUserAction(payload, data, metaData) {
  return async function(dispatch) {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(
        payload,
        data,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(saveUserSuccess(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

export {
  UserManagementActionTypes,
  GetUsersAction,
  GetAllRolesAction,
  GetAllCoursesAction,
  AddNewUserAction,
  SaveUserAction,
  loadUserSuccess,
  saveUserSuccess,
  addUserSuccess,
  loadRoleSuccess,
  loadCourseSuccess,
};
